import script from "./add-point.vue?vue&type=script&lang=ts&setup=true"
export * from "./add-point.vue?vue&type=script&lang=ts&setup=true"

import "./add-point.vue?vue&type=style&index=0&id=66815c8b&lang=scss&scoped=true"

import exportComponent from "D:\\Projects\\WebStorm\\operation-platform\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-66815c8b"]])

export default __exports__